<template>
  <div class="main">
    <report-top>
      <template slot="search">
        <ly-search v-model="searchItem.keyWork" @search="search"></ly-search>
      </template>
    </report-top>
    <div id="formTable">
      <div class="formTableItem">
        <p class="label">时间范围</p>
        <start-end ref="startEnd" timeModel="2,3,0"></start-end>
      </div>
      <div class="formTableItem">
        <p class="label">项目名称</p>
        <div style="width: 120px">
          <selectItems
            :name="searchItem.groupName"
            @update:name="searchItem.groupName = $event"
            :id="searchItem.groupId"
            @update:id="searchItem.groupId = $event"
            clearable
          ></selectItems>
        </div>
      </div>

      <div class="formTableItem">
        <p class="label">所属部门</p>
        <selectGroup
          :name="searchItem.deptName"
          @update:name="searchItem.deptName = $event"
          :id="searchItem.deptId"
          @update:id="searchItem.deptId = $event"
          clearable
        >
        </selectGroup>
      </div>

      <div class="formTableItem">
        <Button @click="chaxun" type="primary" class="chaxun"
          >查询</Button
        >
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="signInAdd">
        <a @click="seePoint(row.signIn)">{{ row.signInAdd }}</a></template
      >
      <template slot-scope="{ row, index }" slot="signOutAdd">
        <a @click="seePoint(row.signOut)">{{ row.signOutAdd }}</a>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <ly-map ref="lymap"></ly-map>
  </div>
</template>
<script>
export default {
  data() {
    return {
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "设备号",
          key: "deviceNo",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "人员姓名",
          key: "personName",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "工号",
          key: "jobNo",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "来源",
          render: (h, data) => {
            return h("div", this.$t("signSource." + data.row.source));
          },
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "项目名称",
          key: "groupName",
          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "签到时间",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.signInTime, "yymmddhhmm"));
          },
          minWidth: 130,
          maxWidth: 200,
        },
        {
          title: "签到地点",
          slot: "signInAdd",
          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "签退时间",
          render: (h, data) => {
            return h(
              "div",
              this.utils.time(data.row.signOutTime, "yymmddhhmm")
            );
          },
          minWidth: 130,
          maxWidth: 200,
        },
        {
          title: "签退地点",
          slot: "signOutAdd",
          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "工作里程/公里",
          key: "mileage",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "工作时长/分",
          key: "duration",
          minWidth: 100,
          maxWidth: 200,
        },
      ],
      tableData: [],
      total: 0,
      searchItem: {
        deviceIdList: [],
        driverIdList: [],
        endTime: 0,
        startTime: 0,
        pageNumber: 1,
        pageSize: 50,
        source: 4, //来源（0-其他，1-平台，2-客户端，3-车载终端，4-人员工牌）,可用值:0,1,2,3,4
      },
    };
  },
  methods: {
    seePoint(v) {
      this.$refs.lymap.open(v);
    },

    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.work + "/checkin/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (const i in data) {
          data[i].signIn = {
            address: data[i].signInAdd,
            lng: data[i].signInX,
            lat: data[i].signInY,
          };
          data[i].signOut = {
            address: data[i].signOutAdd,
            lng: data[i].signOutX,
            lat: data[i].signOutY,
          };
        }
        console.log(data);
        this.tableData = data;
      });
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    chaxun() {
      this.searchItem.startTime = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endTime = this.$refs.startEnd.getTimeObj().end;
      this.getList();
    },
    search() {
      console.log(this.keyWork);
      this.reset();
      this.getList();
    },
    reset() {},
  },
  mounted() {
    this.chaxun();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// ../common/src/components/checkin/person.vue